import React from 'react';
import { AccountListRowData } from '@/experiences/sales-portal/domain/accounts/screens/account-list/types';
import { Cell, flexRender, Row } from '@tanstack/react-table';
import { createStyles } from '@/contexts/theme-context';
import { Pressable } from 'react-native';
import { TableCell } from '@experiences/components/table/table-cell';
import { TableRow } from '@experiences/components/table/table-row';

interface AccountListTableRowProps {
  index: number;
  onRowClick: (row: AccountListRowData) => void;
  row: Row<AccountListRowData>;
}

export const AccountListTableRow = React.memo<AccountListTableRowProps>(
  ({ index, onRowClick, row }) => {
    const [styles, theme] = useStyles();

    const handlePress = () => {
      onRowClick(row.original);
    };

    const visibleCells = row.getVisibleCells();

    return (
      <Pressable
        accessibilityRole="button"
        onPress={handlePress}
        style={styles.pressable}
      >
        {({ hovered }) => {
          const cellBg = hovered
            ? theme.sk.color.bg.secondary.default
            : theme.sk.color.bg.primary.default;

          return (
            <TableRow index={index}>
              {visibleCells.map((cell: Cell<AccountListRowData, unknown>) => (
                <TableCell
                  cell={cell}
                  key={cell.id}
                  style={{ backgroundColor: cellBg }}
                >
                  {flexRender(cell.column.columnDef.cell, {
                    ...cell.getContext(),
                    index,
                  })}
                </TableCell>
              ))}
            </TableRow>
          );
        }}
      </Pressable>
    );
  },
);

const useStyles = createStyles(() => ({
  pressable: {
    cursor: 'pointer',
  },
}));
